import { useFeatureGate } from "@statsig/react-bindings";
import { Suspense } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { ErrorClassifyRender } from "@/Components";
import { featureFlag } from "@/context/FeatureFlagProvider/featureFlags";
import { useInfo } from "@/context/InfoProvider/InfoProvider";
import BrandEquity from "@/pages/brand-equity/BrandEquity";
import BrandEquityV2 from "@/pages/brand-equity/BrandEquityV2";
import Campaigns from "@/pages/campaigns/Campaigns";
import MROIReview from "@/pages/channel-roi/MROI";
import { FinancialReviewV2 } from "@/pages/financial-review/FinancialReviewV2";
import Flighting from "@/pages/flighting/Flighting";
import Formats from "@/pages/formats/Formats";
import Geographies from "@/pages/geographies/Geographies";
import GrowthCenter from "@/pages/growth-center/GrowthCenter";
import { HendrenRouter } from "@/pages/hendren/HendrenRouter";
import InvestmentLevels from "@/pages/investment-levels/InvestmentLevels";
import { MaiteRouter } from "@/pages/maite/MaiteRouter";
import Publishers from "@/pages/publishers/Publishers";
import SalesDriversV2 from "@/pages/sales-drivers/SalesDriversV2";
import { ScenarioV3Router } from "@/pages/scenario-builder/v3/routes/ScenarioV3Router";
import TeamManagement from "@/pages/team-management/index";

import { ProtectedRoute } from "./ProtectedRoute";

const Routes = () => {
  const { currentOrganization } = useInfo();
  const hendrenTier = currentOrganization.configuration.hendrenTier;
  const { value: isGrowthCentreEnabled } = useFeatureGate(featureFlag.growthCentre);
  const { value: isBrandEquityV2Enabled } = useFeatureGate(featureFlag.brandEquityV2);

  const homePageRoute = isGrowthCentreEnabled ? "/growth-center" : "/channel-roi";

  const location = useLocation();
  const background = location.state && location.state.background;

  return (
    <Switch location={background || location}>
      {/* Disable Dashboard  and PanelTabs when MROIEnabled  */}
      <Route exact path="/">
        <Redirect to={homePageRoute} />
      </Route>

      <Route exact path="/home">
        <Redirect to={homePageRoute} />
      </Route>

      <Suspense fallback={<>...</>}>
        <ProtectedRoute
          exact
          path="/team-management"
          component={TeamManagement}
          requireRole="Admin"
        />
        <Route path="/geographies" component={Geographies} />
        <Route path="/campaigns" component={Campaigns} />
        <Route path="/formats" component={Formats} />
        <Route path="/publishers" component={Publishers} />
        <Route path="/investment-levels" component={InvestmentLevels} />
        {isBrandEquityV2Enabled ? (
          <Route path="/brand-equity" component={BrandEquityV2} />
        ) : (
          <Route path="/brand-equity" component={BrandEquity} />
        )}
        <Route path="/flighting" component={Flighting} />
        <Route path="/financial-review" component={FinancialReviewV2} />
        <Route path="/channel-roi" component={MROIReview} />
        <Route path="/sales-drivers" component={SalesDriversV2} />
        <Route path="/maite-v2" component={MaiteRouter} />
        {isGrowthCentreEnabled && <Route path="/growth-center" component={GrowthCenter} />}
        <Route path="/scenarios-v3">
          <ScenarioV3Router />
        </Route>

        <Route path="/scenarios">
          <Redirect to="/scenarios-v3" />
        </Route>

        <Route path="/scenarios-v2">
          <Redirect to="/scenarios-v3" />
        </Route>

        {hendrenTier !== "OFF" && <Route path="/maite*" component={HendrenRouter} />}
      </Suspense>
      <Route render={() => <ErrorClassifyRender ErrorStatus={404} />} />
    </Switch>
  );
};
export default Routes;
